import React from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'hooks';

import { setLoginData } from 'modules/auth/actions';
import { getLoginData } from 'modules/auth/selectors';
import { LoginData } from 'modules/auth/types/InitialState';
import PhoneNumberInput from 'components/ui/PhoneNumberInput';
import { PhoneNumber } from 'modules/selfServices/types/SelfService';
import { Switch } from 'components/ui';
import { FormattedMessage } from 'react-intl';


type BreakdownFormProps = {
  handleOnError:(hasError: boolean) => void
};

const BreakdownForm: React.FC<BreakdownFormProps> = ({ handleOnError }) =>{
  const dispatch = useDispatch();
  const loginData = useSelector(getLoginData);
  const { phoneNumber, isDriver } = loginData;

  const handleChangeLoginData = React.useCallback(
    (data: Partial<LoginData>) => {
      dispatch(setLoginData({ ...loginData, ...data }));
    },
    [dispatch, loginData],
  );

  const setIsDriver = React.useCallback(
    (value: boolean) => handleChangeLoginData({ isDriver: value }),
    [handleChangeLoginData],
  );

  const handlePhoneNumberChange = React.useCallback(
    (value: PhoneNumber) => handleChangeLoginData({ phoneNumber: value }),
    [handleChangeLoginData],
  );

  return (
    <>
      <PhoneNumberInput
        required
        value={phoneNumber}
        onError={handleOnError}
        onChange={handlePhoneNumberChange}
        className="!mb-0"
      />
      <Switch
        size="small"
        checked={isDriver}
        onChange={setIsDriver}
        data-testid="switch-isBreakdown"
        className="mt-xs kioskSharebox:mt-7 border-b-2 pb-xs"
      >
        <FormattedMessage id="login.askBreakdownService" defaultMessage="I am the driver" />
      </Switch>
      <h3 className="text-center">
        <FormattedMessage id="login.vehicleInformation" defaultMessage="Vehicle information" />
      </h3>
    </>
  );
};

export default BreakdownForm;